import { memo } from 'react';
import { useMediaQuery } from '@mui/material';
import AttendeesFilterMob from './mobile/AttendeesFilterMob';
import { AttendeesFilterWeb } from './screen';
import { IAttendeesFiltersProps } from '@src/types';

const AttendeesFilter = (props: IAttendeesFiltersProps) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  return <>{isMobile ? <AttendeesFilterMob {...props} /> : <AttendeesFilterWeb {...props} />}</>;
};

export default memo(AttendeesFilter);
